/* ============================================================
   Modulo: Utility Bar — ticker engine.

   Own copy keyed on data-modulo-ub (the announcement-drop / statement-bar
   precedent — a shared engine would couple two sections' BEM namespaces).

   The unit of repetition is the whole __set, not the individual messages.
   Every cell ends with its own separator, so ONE set width is exactly the
   PITCH between repeats — the thing `scrollWidth` gets wrong, because it
   misses the gap between set N and set N+1 (the hrl lesson).

   Measured inside document.fonts.ready: a webfont lands after this defer
   script and would desync a cycle measured before it (the `as` lesson).

   Re-measured on resize rather than topped up, because <=860px and <=480px
   both change the separator margin and the layout — and a phone rotated to
   landscape crosses both (the `as` lesson).

   window.moduloLazyInit is deliberately NOT used: it does not exist on disk
   (modulo-core.js is absent) and calling it is what live-bugged
   section-stats-progress.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(MQ && MQ.matches); }

  function track(el) { return el.querySelector('[data-ub-track]'); }
  function original(el) { return el.querySelector('[data-ub-set]:not([data-modulo-ub-clone])'); }

  function dropClones(el) {
    var clones = el.querySelectorAll('[data-modulo-ub-clone]');
    for (var i = 0; i < clones.length; i++) clones[i].remove();
  }

  function build(el) {
    var t = track(el);
    if (!t) return;

    // Always start from a clean slate — this runs again on every resize.
    dropClones(el);
    t.removeAttribute('data-modulo-ub-ready');
    t.style.removeProperty('--modulo-ub-cycle-width');

    // Reduced motion: no clones at all, so only the real messages are in the
    // DOM and the CSS wraps them. Checked live, not captured at load, or a
    // mid-session toggle leaves a cloned train behind.
    if (reduced()) return;

    var set = original(el);
    if (!set) return;

    var cycle = set.getBoundingClientRect().width;
    if (cycle <= 0) return; // layout not ready yet

    var viewport = el.offsetWidth || document.documentElement.clientWidth;
    var copies = Math.max(2, Math.ceil((viewport + cycle) / cycle));
    for (var c = 0; c < copies; c++) {
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-modulo-ub-clone', '');
      // Clones must never be reachable by keyboard or they duplicate every stop.
      var focusable = clone.querySelectorAll('a, button');
      for (var f = 0; f < focusable.length; f++) focusable[f].setAttribute('tabindex', '-1');
      t.appendChild(clone);
    }

    t.style.setProperty('--modulo-ub-cycle-width', cycle + 'px');
    t.setAttribute('data-modulo-ub-ready', '1');
  }

  function buildAll() {
    var bars = document.querySelectorAll('[data-modulo-ub]');
    for (var i = 0; i < bars.length; i++) build(bars[i]);
  }

  function boot() {
    buildAll();
    // Fonts change every measurement, so re-run once they have landed.
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(buildAll).catch(function () {});
    }
  }

  /* Document-level listeners are wired exactly once. An identical <script src>
     re-inserted by the theme editor still executes, so without this guard every
     section reload stacks another resize handler (the `as` lesson). */
  if (!window.moduloUbWired) {
    window.moduloUbWired = true;

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildAll, 120);
    });

    if (MQ) {
      if (typeof MQ.addEventListener === 'function') MQ.addEventListener('change', buildAll);
      else if (typeof MQ.addListener === 'function') MQ.addListener(buildAll);
    }

    // Theme editor: re-measure when this section is re-rendered.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-ub]') : null;
      if (root) build(root);
      else buildAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
